import type { Scenario, AbilityDemo } from './types';

export function ScenarioCard({
  scenario,
  abilityLookup,
}: {
  scenario: Scenario;
  abilityLookup: Map<string, AbilityDemo>;
}) {
  return (
    <article id={scenario.slug} className="card scroll-mt-28 space-y-3">
      <header>
        <h3 className="font-serif text-lg text-parchment-50">{scenario.title}</h3>
      </header>
      <p className="text-sm italic text-parchment-100/85 leading-relaxed">
        {scenario.setup}
      </p>
      <div>
        <div className="font-display text-[10px] uppercase tracking-[0.24em] text-gold-400 mb-1">
          Rolls to reach for
        </div>
        <ul className="space-y-1 text-sm">
          {scenario.rolls.map((r, i) => {
            const ref = abilityLookup.get(r.ability);
            return (
              <li key={i} className="flex flex-wrap items-baseline gap-2">
                {ref ? (
                  <button
                    type="button"
                    onClick={() => {
                      const el = document.getElementById(ref.slug);
                      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="font-serif text-parchment-50 underline decoration-gold-400/40 underline-offset-4 hover:decoration-gold-300"
                  >
                    {ref.label}
                  </button>
                ) : (
                  <span className="font-serif text-parchment-50">{r.ability}</span>
                )}
                {ref && (
                  <span className="font-mono text-[12px] text-gold-300">
                    ({ref.roll.formula.split('=').slice(-1)[0].trim()})
                  </span>
                )}
                {r.note && <span className="text-xs muted">— {r.note}</span>}
              </li>
            );
          })}
        </ul>
      </div>
      {scenario.tip && (
        <p className="text-xs muted border-t border-gold-400/10 pt-2">
          <span className="font-display uppercase tracking-[0.22em] text-gold-400 mr-2">
            Tip
          </span>
          {scenario.tip}
        </p>
      )}
    </article>
  );
}
